module.exports = {
    shelfProductTile: {
        showSaveToListAsLink: false,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/shelf-product-tile.js